// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"AccountVerificationForm_recaptcha__3catX","tooltip":"AccountVerificationForm_tooltip__1RAiJ","tooltipText":"AccountVerificationForm_tooltipText__1KLAZ"};